import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DriverRes from "types/res/driver/DriverRes";
import DriverApi from "api/DriverApi";
import LineApi from "api/LineApi";
import {
  Box,
  Button,
  createStyles,
  Divider,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { changeAccount } from "redux/actions/account";
import { useHistory } from "react-router-dom";
const Setting = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const company = useSelector((state: any) => state.account.driver.company);
  const email = useSelector((state: any) => state.account.driver.email);
  const driverId = useSelector((state: any) => state.account.driver.driverId);
  const [driverList, setDriverList] = useState<DriverRes[]>([]);
  const [lineUserId, setLineUserId] = useState("");
  const [notifyMethod, setNotifyMethod] = useState("email");
  const [isLinked, setIsLinked] = useState(false);
  const [lineSaved, setLineSaved] = useState(false);
  const useStyles = makeStyles(() =>
    createStyles({
      button: {},
    })
  );
  const classes = useStyles();
  useEffect(() => {
    const apiCall = async () => {
      const result = await DriverApi.findByEmail(email);
      setDriverList(result);
    };
    apiCall();
  }, []);
  useEffect(() => {
    const fetchLineStatus = async () => {
      try {
        const result: any = await LineApi.getStatus(driverId);
        if (result) {
          setLineUserId(result.lineUserId || "");
          setNotifyMethod(result.notifyMethod || "email");
          setIsLinked(!!result.lineUserId);
        }
      } catch (e) {
        console.error(e);
      }
    };
    if (driverId) fetchLineStatus();
  }, [driverId]);
  const onClickChangeAccount = (driver: DriverRes) => {
    dispatch(changeAccount({ driver }));
  };
  const handleLineSave = async () => {
    try {
      if (lineUserId) {
        await LineApi.link(driverId, lineUserId);
      } else {
        await LineApi.unlink(driverId);
      }
      await LineApi.updateNotifyMethod(driverId, notifyMethod);
      setIsLinked(!!lineUserId);
      setLineSaved(true);
      setTimeout(() => setLineSaved(false), 3000);
    } catch (e) {
      alert("LINE設定の保存に失敗しました");
    }
  };
  return (
    <Box display="flex" flexDirection="column">
      <Box margin={2}>
        <Typography>現在のログイン中企業：{company.name}</Typography>
      </Box>
      <Divider />
      <Box display="flex" flexDirection="column" margin={2}>
        <Typography variant={"subtitle1"}>所属企業一覧</Typography>
        {driverList.map((driver, idx) => (
          <Box
            key={idx}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            marginY={1}
          >
            <Typography>{driver.company.name}</Typography>
            <Button
              variant="contained"
              className={classes.button}
              color="secondary"
              onClick={() => onClickChangeAccount(driver)}
            >
              <Typography>切り替え</Typography>
            </Button>
          </Box>
        ))}
      </Box>
      <Divider />
      <Box display="flex" flexDirection="column" margin={2}>
        <Typography variant={"subtitle1"}>LINE連携</Typography>
        <Box marginTop={1}>
          <Typography variant="body2" color="textSecondary">
            {isLinked ? "✅ LINE連携済み" : "❌ LINE未連携"}
          </Typography>
        </Box>
        <Box marginTop={2}>
          <TextField
            fullWidth
            label="LINE ユーザーID"
            value={lineUserId}
            onChange={(e) => setLineUserId(e.target.value)}
            variant="outlined"
            size="small"
            placeholder="Uxxxxxxxxx..."
          />
        </Box>
        <Box marginTop={2}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel>通知方式</InputLabel>
            <Select
              value={notifyMethod}
              onChange={(e) => setNotifyMethod(e.target.value as string)}
              label="通知方式"
            >
              <MenuItem value="email">メールのみ</MenuItem>
              <MenuItem value="line">LINEのみ</MenuItem>
              <MenuItem value="both">メール+LINE</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box marginTop={2} display="flex" alignItems="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleLineSave}
          >
            LINE設定を保存
          </Button>
          {lineSaved && (
            <Typography style={{ marginLeft: 16, color: "green" }}>
              保存しました
            </Typography>
          )}
        </Box>
      </Box>
      <Divider />
      <Box marginTop={2} display={"flex"} justifyContent={"center"}>
        <Button
          variant="contained"
          className={classes.button}
          color="default"
          onClick={() => history.push("/")}
        >
          トップページへ
        </Button>
      </Box>
    </Box>
  );
};

export default Setting;
